import { SkillConfig } from '../types/onboarding';

interface SkillSetupProps {
  skill: SkillConfig;
  onComplete: () => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

interface SkillRegistration {
  config: SkillConfig;
  setupComponent: React.ComponentType<SkillSetupProps>;
}

class SkillRegistry {
  private skills: Map<string, SkillRegistration> = new Map();

  register(
    config: SkillConfig,
    setupComponent: React.ComponentType<SkillSetupProps>,
  ) {
    this.skills.set(config.id, {
      config,
      setupComponent,
    });
  }

  getSkill(id: string): SkillRegistration | undefined {
    return this.skills.get(id);
  }

  getAllSkills(): SkillConfig[] {
    return Array.from(this.skills.values()).map(
      (registration) => registration.config,
    );
  }

  getSetupComponent(
    id: string,
  ): React.ComponentType<SkillSetupProps> | undefined {
    return this.skills.get(id)?.setupComponent;
  }
}

// Create a singleton instance
export const skillRegistry = new SkillRegistry();

// Export types for consumers
export type { SkillSetupProps };
